import { NOT_APPLICABLE } from '@config/constants/common';
import {
	convertProduction,
	formatDate,
	parseFcApplicable,
} from '@utils/functions';
import {
	getConvertionFactor,
	getNumericProduction,
	getNumericTokenEquivalent,
	parseTokenEquivalentToTCO2E,
} from '@utils/productions';
import isNil from 'lodash/isNil';
import { TProduction } from '../types';
import { TProductionDTO } from '../types/dto';

export const mapProduction = (
	dto: TProductionDTO
): TProduction => {
	const convertionFactor = getConvertionFactor(
		dto.conversionFactorOverride,
		dto.conversionFactor
	);

	const blockchain =
		dto && dto.aco2Token && dto.aco2Token.blockchain
			? dto.aco2Token.blockchain
			: NOT_APPLICABLE;

	const transactionHash =
		dto && dto.aco2Token && dto.aco2Token.transactionHash
			? dto.aco2Token.transactionHash
			: NOT_APPLICABLE;

	const fcApplicable = parseFcApplicable(
		dto.conversionFactorOverride,
		dto.conversionFactor,
		dto.unit
	);

	return {
		...dto,
		fcApplicable,
		mintStatus: dto.status,
		blockchain: blockchain,
		transactionHash: transactionHash,
		site: !isNil(dto.site)
			? dto.site.name
			: NOT_APPLICABLE,
		siteId: !isNil(dto.site)
			? dto.site.id
			: NOT_APPLICABLE,
		organization: !isNil(dto.organization)
			? dto.organization.name
			: NOT_APPLICABLE,
		quantityConverted: convertProduction(
			dto.quantity,
			dto.unit
		),
		production: convertProduction(dto.quantity, dto.unit),
		quantityNumeric: getNumericProduction(
			dto.quantity,
			dto.unit
		),
		entity: !isNil(dto.entity)
			? dto.entity.name
			: NOT_APPLICABLE,
		entityId: !isNil(dto.entity)
			? dto.entity.id
			: NOT_APPLICABLE,
		project: !isNil(dto.project)
			? dto.project.name
			: NOT_APPLICABLE,
		tokenEquivalent: parseTokenEquivalentToTCO2E(
			convertionFactor,
			dto.quantity
		),
		tokenEquivalentNumeric: getNumericTokenEquivalent(
			convertionFactor,
			dto.quantity
		),
		startDate: !isNil(dto.startDate)
			? formatDate(dto.startDate, 'DD/MM/YYYY')
			: NOT_APPLICABLE,
		endDate: !isNil(dto.endDate)
			? formatDate(dto.endDate, 'DD/MM/YYYY')
			: NOT_APPLICABLE,
		createdAt: !isNil(dto.createdAt)
			? formatDate(dto.createdAt, 'DD/MM/YYYY')
			: NOT_APPLICABLE,
	};
};
